import { render, staticRenderFns } from "./ProductImageSettings.vue?vue&type=template&id=70b1e548&scoped=true&"
import script from "./ProductImageSettings.vue?vue&type=script&lang=js&"
export * from "./ProductImageSettings.vue?vue&type=script&lang=js&"
import style0 from "./ProductImageSettings.vue?vue&type=style&index=0&id=70b1e548&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b1e548",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VIcon,VImg,VProgressLinear,VSelect})
